import axios from "axios"
import type { CreatePermitRequestPayload } from "modules/permit"

export interface WorkflowSimulationConditionResult {
  conditionId?: string
  fieldCode?: string
  operator?: string
  expectedValue?: string
  actualValue?: string | null
  description?: string | null
  passed: boolean
}

export interface WorkflowSimulationRuleResult {
  rulesetId: string
  name?: string | null
  priority: number
  matched: boolean
  capStageId?: string | null
  excludeStageIds?: string[]
  conditions: WorkflowSimulationConditionResult[]
}

export interface WorkflowSimulationStage {
  stageId: string
  name: string
  code?: string | null
  approverRole?: string | null
  sequence: number
  isGate: boolean
  approverRoleId?: string | null
  approverRoleCode?: string | null
  approverRoleName?: string | null
  approverRoleDescription?: string | null
}

export interface WorkflowSimulationResult {
  workflowId: string
  workflowVersionId: string
  capStageId?: string | null
  stages: WorkflowSimulationStage[]
  matchedRule?: WorkflowSimulationRuleResult | null
  evaluatedRules?: WorkflowSimulationRuleResult[]
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export async function simulateWorkflow(
  payload: CreatePermitRequestPayload,
): Promise<WorkflowSimulationResult> {
  const response = await axios.post(buildUrl("/api/v1/workflow/simulate"), payload)
  return response.data
}
